import { ENVIRONMENTS } from '@harvestiq/constants';
import { Auth0ProviderOptions, AuthorizationParams } from '@auth0/auth0-react';

function isDevelopmentNodeEnv(): boolean {
  return (
    process.env['NODE_ENV']?.toLowerCase() !== ENVIRONMENTS.PRODUCTION &&
    process.env['NODE_ENV']?.toLowerCase() !== ENVIRONMENTS.TEST
  );
}

function isTestNodeEnv(): boolean {
  return process.env['NODE_ENV']?.toLowerCase() === ENVIRONMENTS.TEST;
}

type ClientAuth0ProviderOptions = Pick<
  Auth0ProviderOptions,
  'domain' | 'clientId' | 'useRefreshTokens'
> & {
  authorizationParams: Pick<AuthorizationParams, 'audience'>;
};

type EnvironmentConfig = {
  env: ENVIRONMENTS;
  version: string;
  auth0: ClientAuth0ProviderOptions & { centralizedAuthClientId: string };
  recaptchaKey: string;
};

const environmentConfigs: Record<ENVIRONMENTS, EnvironmentConfig> = {
  development: {
    env: ENVIRONMENTS.DEVELOPMENT,
    version: getVersion(),
    auth0: {
      domain: 'auth.test.harvestiq.com',
      clientId: 'YJypFnWH1JC84Ucun7kPO4cdLlmZJWJj',
      useRefreshTokens: false,
      authorizationParams: {
        audience: 'https://farmersrisk-test.us.auth0.com/api/v2/',
      },
      centralizedAuthClientId: 'S6dz9wskZdXDeLlhKWxp6D2sskpJPYwv',
    },
    recaptchaKey: '6LfRqDAsAAAAAMYbvcol3pM2k0Ak4kzIli6j3fm4',
  },
  test: {
    env: ENVIRONMENTS.TEST,
    version: getVersion(),
    auth0: {
      domain: 'auth.test.harvestiq.com',
      clientId: 'YJypFnWH1JC84Ucun7kPO4cdLlmZJWJj',
      useRefreshTokens: false,
      authorizationParams: {
        audience: 'https://farmersrisk-test.us.auth0.com/api/v2/',
      },
      centralizedAuthClientId: 'S6dz9wskZdXDeLlhKWxp6D2sskpJPYwv',
    },
    recaptchaKey: '6LfRqDAsAAAAAMYbvcol3pM2k0Ak4kzIli6j3fm4',
  },
  staging: {
    env: ENVIRONMENTS.STAGING,
    version: getVersion(),
    auth0: {
      domain: 'auth.staging.harvestiq.com',
      clientId: 'UHezcx5OXnN1ZddbW10KEHboZbSGIaeL',
      useRefreshTokens: false,
      authorizationParams: {
        audience: 'https://farmersrisk-staging.us.auth0.com/api/v2/',
      },
      centralizedAuthClientId: 'CIewJ2FoZSsLx5JsCmNseTOTDrReeclO',
    },
    recaptchaKey: '6Lf0GjMsAAAAAKQ3p_OJhkiRCHQlN5Cv3y99stzv',
  },
  production: {
    env: ENVIRONMENTS.PRODUCTION,
    version: getVersion(),
    auth0: {
      domain: 'auth.harvestiq.com',
      clientId: 'DRQAmnhymkRIqrcESMdqGHXU7IMB9HLR',
      useRefreshTokens: false,
      authorizationParams: {
        audience: 'https://farmersrisk.us.auth0.com/api/v2/',
      },
      centralizedAuthClientId: '8vS6Wa0qgCTGHl8sFsI34FhwGHjHeYJc',
    },
    recaptchaKey: '6LfnATMsAAAAAMBeJugOewSNhDNbm_0s1SqAkQ8R',
  },
};

export const environmentConfig = environmentConfigs[getEnv()];

function getEnv() {
  if (isDevelopmentNodeEnv() || isTestNodeEnv()) {
    return ENVIRONMENTS.DEVELOPMENT;
  }

  if (window.location.hostname.includes('staging')) {
    return ENVIRONMENTS.STAGING;
  }

  if (window.location.hostname.includes('test')) {
    return ENVIRONMENTS.TEST;
  }

  if (
    window.location.hostname.includes('harvestiq') ||
    window.location.hostname.includes('stockguard')
  ) {
    return ENVIRONMENTS.PRODUCTION;
  }

  return ENVIRONMENTS.DEVELOPMENT;
}

function getVersion() {
  if (isDevelopmentNodeEnv()) {
    return '0.0.1';
  }
  if (process.env.REACT_APP_VERSION) {
    return process.env.REACT_APP_VERSION;
  }

  return '0.0.1';
}
